import { Container, Typography } from '@mui/material';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import List from '@components/List';

import { ASSESSMENTS_DHA, ASSESSMENTS_OTHER } from '@constants/routes';

import { useNavigate } from '@hooks/useNavigate';

const messages = defineMessages({
  select: {
    id: 'assessmentsMain.selectType',
    defaultMessage: 'Select an assessment type',
  },
  view: {
    id: 'assessmentsMain.view',
    defaultMessage: 'View',
  },
  bha: {
    id: 'assessmentsMain.type.bha',
    defaultMessage: 'Digital Health Assessment (DHA)',
  },
  other: {
    id: 'assessmentsMain.type.other',
    defaultMessage: 'Other Assessments',
  },
});

function SelectAssessment() {
  const { formatMessage } = useIntl();
  const { navigateRoute } = useNavigate();

  const assessmentTypes = [
    { label: formatMessage(messages.bha), value: ASSESSMENTS_DHA },
    { label: formatMessage(messages.other), value: ASSESSMENTS_OTHER },
  ];

  const assessmentItems = assessmentTypes.map(({ label, value: route }) => {
    return {
      title: label,
      handleClick: () => navigateRoute(route),
    };
  });

  return (
    <Container maxWidth="sm">
      <Typography
        variant="overline"
        sx={{ display: 'flex', justifyContent: 'center' }}
      >
        {formatMessage(messages.select)}
      </Typography>

      <List items={assessmentItems} type="assessment-list" />
    </Container>
  );
}

export default withErrorBoundary(SelectAssessment, {
  FallbackComponent: ErrorBoundaryFallback,
});
